import { ActionTree } from 'vuex';
import { basePath, ModuleState } from './types';
import { RootState } from '@/types';
import { API } from '@/helpers/axios'

export const actions: ActionTree<ModuleState, RootState> = {
  async fetchAll({ commit }) {
    const response = await API.get(`${basePath}/all`)
    if (response.status === 200) {
      commit('handleResponse', { items: response.data })
      return response.data
    } else {
      commit('handleError', response)
      return false
    }
  }
}